import { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'

import api from '../../../../../services/api'
import { useToast } from '../../../../../hooks/toast'
import { useLoading } from '../../../../../hooks/loading'
import { apiCreate, apiUpdate } from '../../domain/api'
import { nameActions } from '../../domain/info'

import Form, { Input, Textarea } from '../../../../../components/Form'
import Button from '../../../../../components/Button'

type ServiceData = {
  name: string
  description?: string
  price?: string
  tables: {
    [key: number]: { unit_price?: string; wholesale_price?: string }
  }
}

type Table = {
  id: number
  name: string
}

type TypesFormProps = {
  initialValues?: ServiceData & {
    idUpdate: number
  }
  typeForm: 'create' | 'update'
}

export const FormServices = ({
  typeForm,
  initialValues
}: TypesFormProps): JSX.Element => {
  const { addToast } = useToast()
  const history = useHistory()
  const [defaultValues, setDefaultValues] = useState<ServiceData>()
  const { activeLoading, disableLoading } = useLoading()
  const [tables, setTables] = useState<Table[]>([])

  useEffect(() => {
    if (initialValues) {
      setDefaultValues({ ...initialValues })
    }
  }, [initialValues])

  useEffect(() => {
    ;(async () => {
      const tables = await api.get('users/salesTables')
      setTables(tables.data)
    })()
  }, [])

  const onSubmit = async (data: ServiceData) => {
    const tables = Object.entries(data.tables || {}).map(([key, table]) => ({
      table_id: key,
      ...table
    }))
    const a = {
      ...data,
      tables
    }
    try {
      if (typeForm === 'create') {
        try {
          const dataCreate = {
            ...a
          }
          activeLoading()
          await api.post(apiCreate(), dataCreate)
          disableLoading()
          addToast({
            type: 'success',
            title: 'Registro criado',
            description: 'Registro criado com sucesso'
          })
          history.push(nameActions.read.to)
        } catch (error) {
          addToast({
            type: 'error',
            title: 'Erro ao adicionar o registro',
            description:
              'Ocorreu um erro ao fazer cadastro, por favor, tente novamente.'
          })
          disableLoading()
        }
      } else {
        const dataUpdate = {
          ...a
        }
        const id = initialValues?.idUpdate

        try {
          activeLoading()
          await api.put(apiUpdate(String(id)), dataUpdate)
          disableLoading()
          history.push(nameActions.read.to)
          addToast({
            type: 'success',
            title: 'Registro atualizado',
            description: 'Registro alterado com sucesso'
          })
        } catch (error) {
          history.push(nameActions.read.to)
          addToast({
            type: 'error',
            title: 'Erro ao atualizar o registro',
            description:
              'Ocorreu um erro ao fazer a atualização, por favor, tente novamente.'
          })
        }
      }
      disableLoading()
    } catch (err) {
      if (typeForm === 'create') {
        addToast({
          type: 'error',
          title: 'Erro no cadastro',
          description:
            'Ocorreu um erro ao fazer cadastro, por favor, tente novamente.'
        })
      }
    }
  }

  return (
    <div className="card mb-5 mb-xl-10">
      <Form onSubmit={onSubmit} defaultValues={defaultValues}>
        <h2>Detalhes</h2>
        <div className="row">
          <Input
            label="Nome"
            name="name"
            className="col-md-6"
            rules={{ required: true }}
          />
          <Textarea
            label="Descrição"
            name="description"
            rows={5}
            className="col-md-12"
            rules={{ required: true }}
          />
        </div>
        <div className="separator my-7" />
        <h2>Valores</h2>
        <div className="row">
          <Input
            label="Preço de custo"
            name="price"
            className="col-md-3"
            rules={{ required: true }}
            price
          />
        </div>
        <div className="row">
          <div className="col-md-8">
            <h6 className="mt-3">Tabelas</h6>
            <div className="row fs-6">
              <div className="col-md-2"></div>
              <div className="col-md-3 mb-2">Preço unitário</div>
              <div className="col-md-3 mb-2">Preço atacado</div>
            </div>
            {tables?.map(table => (
              <div className="row" key={table.id}>
                <div className="col-md-2">
                  <span className="mt-5">{table.name}</span>
                </div>
                <div className="col-md-3">
                  <Input
                    name={`tables.${table.id}.unit_price`}
                    price
                    rules={{ required: true }}
                  />
                </div>
                <div className="col-md-3">
                  <Input
                    name={`tables.${table.id}.wholesale_price`}
                    price
                    rules={{ required: true }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="card-footer d-flex justify-content-end py-6 px-9">
          <Button type="submit" className="btn btn-primary">
            Salvar
          </Button>
        </div>
      </Form>
    </div>
  )
}
